import {charcoal} from '../../sass/v2/_exports.sass';

export const BoldTextIcon = ({color = charcoal, className = '', ratio = 1}) => {
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Bold text</title>
      <path
        d="M9.78516 24.8333V7.16666H16.2672C17.626 7.16666 18.8547 7.58976 19.9532 8.43599C21.0513 9.28199 21.6005 10.4213 21.6005 11.854C21.6005 12.8504 21.3599 13.6628 20.8785 14.2909C20.3973 14.9192 19.8791 15.3752 19.3235 15.6589C20.0073 15.8948 20.6603 16.3611 21.2825 17.0577C21.9047 17.7544 22.2159 18.6923 22.2159 19.8717C22.2159 21.5759 21.5876 22.8289 20.3312 23.6307C19.0747 24.4324 17.8089 24.8333 16.5339 24.8333H9.78516ZM12.6518 22.1771H16.4261C17.4757 22.1771 18.2176 21.8856 18.6519 21.3027C19.086 20.7197 19.3032 20.1608 19.3032 19.6256C19.3032 19.0905 19.086 18.5316 18.6519 17.9487C18.2176 17.3657 17.4552 17.0744 16.3645 17.0744H12.6518V22.1771ZM12.6518 14.5H16.1108C16.9211 14.5 17.5633 14.2684 18.0379 13.8051C18.512 13.3419 18.7492 12.7872 18.7492 12.141C18.7492 11.4539 18.4984 10.8923 17.9968 10.4563C17.4951 10.0205 16.88 9.80266 16.1519 9.80266H12.6518V14.5Z"
        fill={color}
      />
    </svg>
  );
};
